var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintManifest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28906 4.98053V2.0641C3.28906 1.74881 3.48804 1.09459 4.28395 1H12.7958C13.1152 1.05255 13.7465 1.33894 13.717 2.0641V4.98053",
    stroke: "#55565A",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21891 12.1929C1.78902 11.9827 0.943975 11.3416 1.00293 10.4588V6.99065C1.03978 6.39948 1.43037 5.20926 2.69793 5.17773H14.1576C14.7717 5.25656 16 5.72949 16 6.99065V10.2618C15.9754 10.5902 15.7126 11.3968 14.8577 11.9959",
    stroke: "#55565A",
    strokeWidth: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36523 9.5127H14.5619",
    stroke: "#55565A",
    strokeWidth: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39731 9.5127V16.2126C3.37274 16.5016 3.50048 17.1269 4.20796 17.3161H12.683C13.0023 17.3687 13.6631 17.2688 13.7516 16.4491V10.025",
    stroke: "#55565A",
    strokeWidth: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42383 12.0745H11.5406",
    stroke: "#55565A",
    strokeWidth: 0.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14.5969H10.0323",
    stroke: "#55565A",
    strokeWidth: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2793 7.42383H13.6795",
    stroke: "#55565A",
    strokeWidth: 0.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintManifest);
export default __webpack_public_path__ + "static/media/print-manifest.65dbba80b3f9d97b1372a99b0f2457dc.svg";
export { ForwardRef as ReactComponent };